import axios from '@/plugins/axiosPlugin'

export default {
  state: {
    materials: [],
    materialsLoading: false,

    selectedMaterial: null,
    selectedMaterialLoading: false,

    selectedMaterials: [], 
    selectedMaterialsLoading: false,

    pagination: {
      page: 1,
      per_page: 50,
      total: 0,
    }
  },

  mutations: {
    setMaterials(state, materials) {
      state.pagination = materials.pagination
      state.materials = materials.data
    },
    setMaterialsLoading(state, materialsLoading) {
      state.materialsLoading = materialsLoading
    },
    setSelectedMaterial(state, material) {
      state.selectedMaterial = material
    },
    setSelectedMaterialLoading(state, loading) {
      state.selectedMaterialLoading = loading
    },
    setSelectedMaterials(state, materials) {
      state.selectedMaterials = materials
    },
    setSelectedMaterialsLoading(state, loading) {
      state.selectedMaterialsLoading = loading
    }
  },

  actions: {
    getAllMaterials(context, { page, per_page, sort_by, filter }) {
      context.commit('setMaterialsLoading', true)
      const params = new URLSearchParams();
      params.append('page', page);
      params.append('per_page', per_page);
      params.append('sort_by', sort_by);
      params.append('filter', filter);
      axios
        .get('lagerverwaltung/material', { params})
        .then((response) => context.commit('setMaterials', response.data))
        .catch(() => console.log("Error"))
        .finally(() => context.commit('setMaterialsLoading', false))
    },

    //getAllMaterialsDate(context, { startDatum, endDatum }) {
    //  context.commit('setMaterialsLoading', true)
    //  const params = new URLSearchParams();
    //  params.append('startDatum', startDatum);
    //  params.append('endDatum', endDatum);
    //  axios
    //    .get('lagerverwaltung/material', { params })
    //    .then((response) => context.commit('setMaterials', response))
    //    .catch(() => console.log("Error"))
    //    .finally(() => context.commit('setMaterialsLoading', false))
    //},
    
    registerMaterialPromise(context, material) {
      return axios.put('lagerverwaltung/material', material)
    },
    editMaterialPromise(context, material) {
      return axios.post('lagerverwaltung/material/' + material.ID, material)
    },
    deleteMaterialPromise(context, materialID) {
      return axios.delete('lagerverwaltung/material/' + materialID)
    },
    getMaterialPromise(context, materialID) {
      return axios.get('lagerverwaltung/material/' + materialID)
    },

    // Bestehende Einzelabruf-Funktion
    getMaterialDetails(context, id) {
      context.commit('setSelectedMaterialLoading', true)
      return axios
        .get(`lagerverwaltung/material/${id}`)
        .then((response) => {
          context.commit('setSelectedMaterial', response.data.data)
          return response.data.data
        })
        .catch(console.log("Error"))
        .finally(() => context.commit('setSelectedMaterialLoading', false))
    },
    async getMultipleMaterials(context, ids) {
      context.commit('setSelectedMaterialsLoading', true)
      const requests = ids.map(id =>
        axios.get(`lagerverwaltung/material/${id}`).then(res => res.data.data)
      )
      try {
        const results = await Promise.all(requests)
        context.commit('setSelectedMaterials', results)
      } catch (e) {
        console.log('Fehler beim Laden mehrerer Materialien')
      } finally {
        context.commit('setSelectedMaterialsLoading', false)
      }
    }
  }
}
